@if (visible) {
  <div
    class="p-message p-component"
    [attr.aria-live]="'polite'"
    [attr.role]="'alert'"
    [ngClass]="containerClass"
    [ngStyle]="styleObject"
    [attr.style]="styleString"
    >
    <div class="p-message-content">
      @if (computedIcon) {
        <i class="p-message-icon" [ngClass]="computedIcon"></i>
      }
      @if (text !== undefined && text !== null && text !== '') {
        @if (escape) {
          <span class="p-message-text">{{ text }}</span>
        } @else {
          <span class="p-message-text" [innerHTML]="text"></span>
        }
      } @else {
        <span class="p-message-text">
          <ng-content></ng-content>
        </span>
      }
      @if (closable) {
        <button type="button" class="p-message-close-button" (click)="close($event)" aria-label="Close">
          <i class="p-message-close-icon" [ngClass]="closeIcon || 'pi pi-times'"></i>
        </button>
      }
    </div>
  </div>
}

